/* ===== Mitti Heritage theme JS: announcement rotation + cart drawer ===== */
(function () {
  'use strict';

  /* ---- announcement rotation (5s) ---- */
  var msgs = document.querySelectorAll('.announce .a-msg');
  if (msgs.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var idx = 0;
    setInterval(function () {
      msgs[idx].classList.remove('on');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('on');
    }, 5000);
  }

  var SHIP_NOW = 'Now, ahead of Mango Basket';
  var SHIP_LATER = 'With Mango Basket, December 3 to 4';
  /* Gift notes are saved hidden (underscore) so checkout never promises a gift to someone who then enters a code.
     The bag shows the gift; the order job drops it on coded orders. */
  if (window.fetch && !window.__mittiGiftWrap) {
    window.__mittiGiftWrap = true;
    var _f = window.fetch;
    var hide = function (o) {
      var p = o && o.properties; if (!p) return;
      if (p['Holiday gift']) { p['_Holiday gift'] = p['Holiday gift']; delete p['Holiday gift']; }
      if (p['_Holiday gift']) p['Gift'] = 'Silver case with three 2 ml vials (not with discount codes)';
      if (window.__mittiEarly && (p['Ships'] || p['_Mango Pair'])) p['Ships'] = SHIP_NOW;
    };
    window.fetch = function (u, opt) {
      try {
        if (opt && typeof opt.body === 'string' && /\/cart\/(add|change)(\.js)?/.test(String(u))) {
          var j = JSON.parse(opt.body);
          if (j.items) j.items.forEach(hide); else hide(j);
          opt = Object.assign({}, opt, { body: JSON.stringify(j) });
        }
      } catch (e) {}
      return _f.call(this, u, opt);
    };
  }

  /* ---- cart drawer ---- */
  var drawer = document.getElementById('MittiDrawer');
  var scrim = document.getElementById('MittiScrim');
  var badge = document.getElementById('MittiCartBadge');
  var FREE_SHIP = (window.MITTI && window.MITTI.freeShipThreshold) || 100;
  /* products that ship free on their own (Discovery Set Free Shipping profile) */
  var FREE_HANDLES = ['discovery-set', 'discovery-travel-spray'];
  /* "send the rest sooner" choice, saved on the order as a cart attribute */
  var EARLY_KEY = 'Ship early';
  var EARLY_VAL = 'Yes: send other items and gifts now, Mango Basket follows Dec 3 to 4';
  var money = function (cents) {
    var v = cents / 100;
    return '<span class="pricefig"><span class="cur">$</span>' + (v % 1 === 0 ? v : v.toFixed(2)) + '</span>';
  };
  var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var isMango = function (it) { return it.handle === 'mango-basket' || String(it.sku || '').indexOf('MANGO-35') === 0; };
  function lineMeta(it, coded) {
    var bits = [];
    var p = it.properties || {};
    var pairGift = p['Holiday gift'] || p['_Holiday gift'];
    if (it.variant_title && it.variant_title !== 'Default Title') bits.push(pairGift && isMango(it) ? '35 ml' : esc(it.variant_title));
    Object.keys(p).forEach(function (k) {
      if (!p[k]) return;
      if (k === 'Holiday gift' || k === '_Holiday gift') { if (!coded) bits.push('<em>Free: silver case with three 2 ml vials</em>'); return; }
      if (k.charAt(0) === '_') return;
      if (k === 'Gift') { if (!pairGift) bits.push('<em>Free: ' + esc(p[k]) + '</em>'); }
      else if (k === 'Ships') bits.push(esc(p[k]));
    });
    return bits.length ? '<div class="line-meta" style="font-size:13px;line-height:1.4;opacity:.85;margin:2px 0 6px">' + bits.join('<br>') + '</div>' : '';
  }

  function postJ(u, b) { return fetch(u, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(b) }).then(function (r) { return r.json(); }); }
  function setEarly(on) {
    window.__mittiEarly = on;
    var a = {}; a[EARLY_KEY] = on ? EARLY_VAL : '';
    return postJ('/cart/update.js', { attributes: a }).then(function (cart) {
      if (!cart.items || !cart.items.some(isMango)) return cart;
      var want = on ? SHIP_NOW : SHIP_LATER, chain = Promise.resolve(cart);
      cart.items.forEach(function (it, i) {
        if (isMango(it)) return;
        var p = Object.assign({}, it.properties || {});
        if (p['Ships'] === want) return;
        p['Ships'] = want;
        chain = chain.then(function () { return postJ('/cart/change.js', { line: i + 1, quantity: it.quantity, properties: p }); });
      });
      return chain;
    });
  }
  function earlyBox(checked, text) {
    return '<label data-early-wrap style="display:flex;gap:10px;align-items:flex-start;cursor:pointer;text-align:left">' +
      '<input type="checkbox" data-ship-early ' + (checked ? 'checked ' : '') + 'style="margin:2px 0 0;width:18px;height:18px;flex:none;accent-color:#6b2a17">' +
      '<span>' + text + '</span></label>';
  }
  var EARLY_TEXT = '<b>Want the rest sooner?</b> Tick this and we\'ll send your other pieces and your gifts now, so you can start wearing them. Mango Basket follows, December 3 to 4.';

  /* Mango in the cart: everything ships together Dec 3 to 4 unless the customer ticks "send the rest sooner". */
  function renderShipNote(cart) {
    var foot = drawer && drawer.querySelector('.drawer-foot');
    if (!foot) return;
    var box = foot.querySelector('[data-ship-note]');
    var hasMango = cart.items.some(isMango), hasOther = cart.items.some(function (i) { return !isMango(i); });
    /* "Leaves us in 1 to 3 business days" contradicts the Mango date, so it hides while Mango is in the cart. */
    document.querySelectorAll('.cr-dispatch').forEach(function (el) { el.style.display = hasMango ? 'none' : ''; });
    if (!hasMango) { if (box) box.remove(); return; }
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-ship-note', '');
      box.style.cssText = 'margin:0 0 12px;padding:10px 12px;border-radius:8px;background:rgba(107,42,23,.06);font-size:13px;line-height:1.45';
      foot.insertBefore(box, foot.firstChild);
    }
    var on = !!(cart.attributes && cart.attributes[EARLY_KEY]);
    window.__mittiEarly = on;
    box.innerHTML = hasOther ? earlyBox(on, EARLY_TEXT) : 'Mango Basket ships December 3 to 4.';
  }

  /* Mango Pair on the Mango Basket page goes straight to checkout, so offer the same choice right under the gift. */
  function pairEarly() {
    var hsGift = document.querySelector('[data-hs-card="pair"] .hs-giftbox');
    if (hsGift) addEarlyUnder(hsGift, '#f1e3c4', '#4e1c11');
    var gift = document.querySelector('[data-mpr] .mpr-gift');
    if (!gift) return;
    var sub = gift.querySelector('span');
    if (sub) sub.textContent = 'A $75 value, yours with the pair. Not combined with discount codes.';
    addEarlyUnder(gift, '#f7f0e6', '#5a2414');
  }
  function addEarlyUnder(gift, bg, ink) {
    if (gift.parentNode.querySelector('[data-early-wrap]')) return;
    var holder = document.createElement('div');
    holder.style.cssText = 'margin:10px 0 0;padding:10px 12px;border-radius:10px;background:' + bg + ';font-size:13px;line-height:1.45;color:' + ink;
    holder.innerHTML = earlyBox(false, '<b>Want your 2nd bottle and the silver case sooner?</b> Tick this and we\'ll send them now. Mango Basket follows, December 3 to 4.');
    gift.parentNode.insertBefore(holder, gift.nextSibling);
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var on = !!(c.attributes && c.attributes[EARLY_KEY]); window.__mittiEarly = on;
      var cb = holder.querySelector('[data-ship-early]'); if (cb) cb.checked = on;
    }).catch(function () {});
  }

  function renderCart(cart) {
    if (badge) badge.textContent = cart.item_count > 0 ? cart.item_count : '';
    var body = drawer && drawer.querySelector('.drawer-body');
    var foot = drawer && drawer.querySelector('.drawer-foot');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="empty">Your cart is empty, for now.</p>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    var coded = (cart.discount_codes || []).some(function (d) { return d.applicable; });
    var gifted = cart.items.some(function (it) { var p = it.properties || {}; return p['Holiday gift'] || p['_Holiday gift']; });
    var html = '';
    cart.items.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_180x$1$2') : '';
      html += '<div class="line">' +
        (img ? '<img src="' + img + '" alt="">' : '<span style="width:60px"></span>') +
        '<div class="line-info"><div class="line-top">' +
        '<a class="line-name" href="' + it.url + '">' + it.product_title + '</a>' +
        '<span class="line-price">' + money(it.final_line_price) + '</span></div>' +
        lineMeta(it, coded) +
        '<div class="qty" data-key="' + it.key + '">' +
        '<button data-q="' + (it.quantity - 1) + '" aria-label="Decrease"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
        '<span>' + it.quantity + '</span>' +
        '<button data-q="' + (it.quantity + 1) + '" aria-label="Increase"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div></div></div>';
    });
    if (coded && gifted) html += '<p class="line-meta" style="font-size:13px;line-height:1.4;opacity:.85;margin:8px 0 0">The silver case gift isn\'t included when a discount code is used.</p>';
    body.innerHTML = html;

    var subtotal = cart.items_subtotal_price;
    var setOnly = cart.items.length > 0 && cart.items.every(function (it) { return FREE_HANDLES.indexOf(it.handle) > -1; });
    var free = subtotal >= FREE_SHIP * 100 || setOnly;
    var note = drawer.querySelector('.ship-note');
    var bar = drawer.querySelector('.ship-bar i');
    var sub = drawer.querySelector('.subtotal .sub-v');
    if (note) note.innerHTML = free ? '<em>Ships free</em>' : "You're <em>$" + Math.ceil((FREE_SHIP * 100 - subtotal) / 100) + '</em> from free U.S. shipping';
    if (bar) bar.style.width = (free ? 100 : Math.min(100, (subtotal / (FREE_SHIP * 100)) * 100)) + '%';
    if (sub) sub.innerHTML = money(subtotal);
    renderShipNote(cart);
  }

  function refresh(open) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      renderCart(c);
      if (open) openDrawer();
      return c;
    });
  }

  function openDrawer() {
    if (drawer) drawer.classList.add('open');
    if (scrim) scrim.classList.add('show');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('open');
    if (scrim) scrim.classList.remove('show');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-ship-early]');
    if (!cb) return;
    cb.disabled = true;
    setEarly(cb.checked).catch(function () {}).then(function () {
      cb.disabled = false;
      if (document.querySelector('.cart-page')) { location.reload(); return; }
      if (drawer && drawer.contains(cb)) refresh(false);
    });
  });

  document.addEventListener('click', function (e) {
    var t;
    /* open drawer */
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refresh(true); return; }
    /* close */
    if (e.target.closest('[data-cart-close]') || e.target === scrim) { closeDrawer(); return; }
    /* add to cart */
    t = e.target.closest('[data-add-variant]');
    if (t) {
      e.preventDefault();
      t.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(t.getAttribute('data-add-variant'), 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refresh(true);
      }).catch(function () {
        window.location.href = t.getAttribute('data-fallback-url') || '/cart';
      }).finally(function () { t.disabled = false; });
      return;
    }
    /* qty change */
    t = e.target.closest('.qty button');
    if (t && drawer && drawer.contains(t)) {
      var key = t.closest('.qty').getAttribute('data-key');
      var q = Math.max(0, parseInt(t.getAttribute('data-q'), 10));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: q })
      }).then(function (r) { return r.json(); }).then(renderCart);
      return;
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* product forms that should use the drawer */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-ajax-cart]');
    if (!f) return;
    e.preventDefault();
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw 0; return refresh(true); })
      .catch(function () { f.removeAttribute('data-ajax-cart'); f.submit(); });
  });

  /* The Discovery Set card stays off the Mango and Holiday Sets pages, so it doesn't pull bigger orders down to $52. */
  function noDock() { if (document.querySelector('[data-ml], [data-hs]')) { var d = document.getElementById('DiscoDock'); if (d) d.remove(); } }
  noDock();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { pairEarly(); noDock(); }); else pairEarly();
  refresh(false);
})();
